import React from 'react'
import Header from 'components/template/Header'
import SidePanel from 'components/template/SidePanel'
import UserDropdown from 'components/template/UserDropdown'
import HeaderLogo from 'components/template/HeaderLogo'
import MobileNav from 'components/template/MobileNav'
import HorizontalNav from 'components/template/HorizontalNav'
import View from 'views'
import LanguageSelector from 'components/template/LanguageSelector'
import store from '../../store/index'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ActionLink } from 'components/shared'
import { useSelector } from 'react-redux'
import Basket from 'components/template/Basket'

const HeaderActionsStart = () => {
    return (
        <>
            <HeaderLogo />
            <MobileNav />
        </>
    )
}

const HeaderActionsEnd = () => {
    const user = store.getState().auth.user
    const authenticated = Object.keys(user).length > 0
    const { t } = useTranslation()
    const lang = useSelector((state) => state.locale.currentLang)
    let signInUrl = `/auth/${lang}/sign-in-simple`
    return (
        <>
            <Basket />
            <LanguageSelector />
            <SidePanel />
            {authenticated ? (
                <UserDropdown hoverable={true} />
            ) : (
                <ActionLink to={signInUrl}>
                    {t('signInSample:content.signInForm.signIn')}
                </ActionLink>
            )}
        </>
    )
}

const SimpleLayout = () => {
    return (
        <div className="app-layout-simple flex flex-auto flex-col min-h-screen">
            <div className="flex flex-auto min-w-0">
                <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
                    <Header
                        container
                        className="shadow dark:shadow-2xl"
                        headerStart={<HeaderActionsStart />}
                        headerMiddle={<HorizontalNav />}
                        headerEnd={<HeaderActionsEnd />}
                    />
                    <View pageContainerType="contained" />
                </div>
            </div>
        </div>
    )
}

export default SimpleLayout
